module.exports = __webpack_public_path__ + "img/icon_t15.1c22ff4c.png";